import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  IconButton,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

export const PreviewModal = ({
  open,
  onClose,
  onPublish,
  loading,
  isSaved,
  onReload,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
    >
      <DialogTitle>
        Vista previa

        <Tooltip title="Cerrar vista previa">
          <IconButton
            onClick={onClose}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </Tooltip>
      </DialogTitle>

      <DialogContent sx={{ p: 0 }}>
        <iframe
          src="https://app.elmediodemedios.com/bloques/boletin"
          width="100%"
          height="600px"
          style={{ border: "none" }}
          title="Vista previa"
        />
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Tooltip title="Cerrar vista previa">
          <Button
            onClick={() => {
              onReload();
              onClose();
            }}
            variant="outlined"
          >
            Cerrar
          </Button>
        </Tooltip>

        <Tooltip title="Publica los cambios en producción">
          <Button
            variant="contained"
            startIcon={<CloudUploadIcon />}
            onClick={onPublish}
            disabled={!isSaved || loading}
            sx={{
              background: "linear-gradient(95deg,#2563eb,#1d4ed8)",
            }}
          >
            {loading ? "Publicando..." : "Publicar a producción"}
          </Button>
        </Tooltip>
      </DialogActions>
    </Dialog>
  );
};
